import React, { useState, useEffect, useCallback, useContext } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  IconButton,
  LinearProgress,
  Tooltip,
} from "@mui/material";
import EditProfile from "./EditProject";
import DeleteProjectModel from "./DeleteProjectModel";
import AuthContext from "../../store/AuthContext";
import axios from "axios";
import {
  androidicon,
  deleteicons,
  edit,
  phplang,
  ReactJsIcon,
} from "../../iconsImports";
import CreateTaskForm from "./CreateTaskForm";
import NoDataView from "../../component/NoDataView";
// Function to calculate duration in days
const calculateDuration = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const diffTime = end - start;
  const diffDays = diffTime / (1000 * 3600 * 24);
  return diffDays;
};

// Function to calculate days left
const calculateDaysLeft = (endDate) => {
  const today = new Date();
  const end = new Date(endDate);
  const diffTime = end - today;
  const diffDays = diffTime / (1000 * 3600 * 24);
  return Math.max(0, Math.ceil(diffDays));
};
const getTechnologyIcon = (tech) => {
  switch (tech.toLowerCase()) {
    case "react js":
      return (
        <img style={{ width: "25px" }} src={ReactJsIcon} alt="edit icon" />
      );
    case "react native":
      return <img src={androidicon} alt="edit icon" />;
    case "php":
      return <img src={phplang} alt="edit icon" />;
    default:
      return null; // Return null if no matching icon is found
  }
};
const ProjectDashboard = ({ data, refresh }) => {
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openEditTask, setOpenEditTask] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [imageURLs, setImageURLs] = useState({});
  const [imageLoadStatus, setImageLoadStatus] = useState({}); // Track image load status
  const authCtx = useContext(AuthContext);
  const token = authCtx.token;
  const user = authCtx.user;

  useEffect(() => {
    // Set the initial list of projects and filtered projects
    setProjects(data);
    setFilteredProjects(data); // Initially set filtered projects to the full list
  }, [data]);

  const handleDeleteClick = (project) => {
    setSelectedProject(project);
    setOpenDeleteModal(true);
  };

  const refreshFunc = () => {};

  const handleEditClick = (project) => {
    setSelectedProject(project);
    setOpenEditModal(true);
  };

  const handleCloseEditModal = () => {
    setOpenEditModal(false);
    setSelectedProject(null);
  };

  const handleDeleteSuccess = () => {
    refreshFunc();
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    if (value === "") {
      setFilteredProjects(projects); // Show all projects when search is empty
    } else {
      const filtered = projects.filter((project) =>
        project.name.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredProjects(filtered); // Update the filtered list based on search term
    }
  };

  // useEffect(() => {
  //   const fetchImages = async () => {
  //     const newImageURLs = {};

  //     await Promise.all(
  //       data.map(async (project) => {
  //         if (project.project_image) {
  //           const imageUrl = await fetchImage(project.project_image, token);
  //           if (imageUrl) {
  //             newImageURLs[project.id] = imageUrl;
  //           }
  //         }
  //       })
  //     );

  //     setImageURLs(newImageURLs);
  //   };

  //   fetchImages();
  // }, [data, token]);

  const handleImageUpdate = (projectId, newImageUrl) => {
    setImageURLs((prevURLs) => ({
      ...prevURLs,
      [projectId]: newImageUrl,
    }));
  };

  const handleImageLoad = (projectId) => {
    setImageLoadStatus((prevStatus) => ({
      ...prevStatus,
      [projectId]: true,
    }));
  };

  return (
    <Box sx={{}}>
      <Grid container spacing={3}>
        {filteredProjects.length ? (
          filteredProjects.map((project) => (
            <Grid item xs={12} sm={6} md={3} sx={{ mt: 1.5 }} key={project.id}>
              <Card sx={{ borderRadius: "18px", pl: 3, pt: 3, pr: 3, mt: 5 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Box
                    sx={{
                      position: "absolute",
                      width: "80px",
                      height: "80px",
                      padding: 0.7,
                      mb: 7,
                      borderRadius: "50%",
                      overflow: "hidden",
                      border: "4px solid #ADD8E6",
                    }}
                  >
                    <img
                      src={project.project_image}
                      alt={project.name}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                </Box>

                <Box sx={{ mt: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <Box sx={{ display: "flex" }}>
                      {project.technologies.split(",").map((tech) => (
                        <Box key={tech} sx={{ p: 1 }}>
                          {getTechnologyIcon(tech.trim())}
                        </Box>
                      ))}
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        gap: 1,
                        position: "relative",
                        top: "-30px",
                      }}
                    >
                      {" "}
                      {/* Adjusted position */}
                      {user.role === "Admin" && (
                        <IconButton
                          color="success"
                          onClick={() => handleEditClick(project)}
                        >
                          <img src={edit} alt="edit icon" />
                        </IconButton>
                      )}
                      {user.role === "Admin" && (
                        <IconButton
                          color="error"
                          onClick={() => handleDeleteClick(project)}
                        >
                          <img src={deleteicons} alt="delete icon" />
                        </IconButton>
                      )}
                    </Box>
                  </Box>

                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Tooltip title={`End Date: ${project.end_date}`} arrow>
                        <Typography>
                          {" "}
                          ⏳ {calculateDaysLeft(project.end_date)} Days Left
                        </Typography>
                      </Tooltip>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography>
                        🕰️{" "}
                        {calculateDuration(
                          project.start_date,
                          project.end_date
                        )}{" "}
                        Days
                      </Typography>
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: 0.5 }}>
                      <Grid
                        item
                        xs={4}
                        container
                        direction="column"
                        alignItems="center"
                      >
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Typography variant="body2">👥</Typography>
                          <Typography variant="h6" sx={{ mt: 0.5 }}>
                            {project.tasksCount || 0}
                          </Typography>
                        </Box>
                        <Typography variant="body2">Tasks</Typography>
                      </Grid>

                      <Grid
                        item
                        xs={4}
                        container
                        direction="column"
                        alignItems="center"
                      >
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Typography variant="body2">👥</Typography>
                          <Typography variant="h6" sx={{ mt: 0.5 }}>
                            {project.tasksCount - project.completeCount || 0}
                          </Typography>{" "}
                          {/* Pending count */}
                        </Box>
                        <Typography variant="body2">Pending</Typography>{" "}
                        {/* Text below */}
                      </Grid>

                      <Grid
                        item
                        xs={4}
                        container
                        direction="column"
                        alignItems="center"
                      >
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Typography variant="body2">👥</Typography>
                          <Typography variant="h6" sx={{ mt: 0.5 }}>
                            {project.completeCount || 0}
                          </Typography>{" "}
                          {/* Complete count */}
                        </Box>
                        <Typography variant="body2">Completed</Typography>{" "}
                        {/* Text below */}
                      </Grid>
                    </Grid>
                  </Grid>
                  <LinearProgress
                    variant="determinate"
                    value={
                      project.tasksCount > 0
                        ? (
                            (project.completeCount / project.tasksCount) *
                            100
                          ).toFixed(2)
                        : 0
                    }
                    sx={{ mt: 2, mb: 2, borderWidth: 2, borderColor: "#000" }}
                  />

                  <Grid
                    container
                    spacing={1}
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Grid item xs={6}>
                      <CreateTaskForm
                        project={project}
                        setOpenEditTask={setOpenEditTask}
                        taskcreate={"true"}
                        refresh={refresh}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Typography>
                        {project.tasksCount > 0 ? (
                          <Typography>
                            Progress:{" "}
                            {(
                              (project.completeCount / project.tasksCount) *
                              100
                            ).toFixed(2)}
                            %
                          </Typography>
                        ) : (
                          <Typography>No tasks available</Typography>
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box
                  sx={{
                    width: "125%",
                    display: "flex",
                    alignItems: "flex-end",
                    ml: -4,
                  }}
                >
                  <Typography
                    sx={{
                      mt: 1,
                      p: 1,
                      bgcolor: "#ffcccc",
                      borderRadius: "10px",
                      width: "100%",
                    }}
                  >
                    {project.name}
                  </Typography>
                </Box>
              </Card>
            </Grid>
          ))
        ) : (
          <NoDataView />
        )}
      </Grid>
      <EditProfile
        open={openEditModal}
        handleClose={handleCloseEditModal}
        projectData={selectedProject}
        refresh={refresh}
        handleImageUpdate={handleImageUpdate}
      />

      <DeleteProjectModel
        open={openDeleteModal}
        handleClose={() => setOpenDeleteModal(false)}
        selectedProject={selectedProject}
        refresh={refresh}
      />
    </Box>
  );
};

export default ProjectDashboard;
